import React from 'react';
import { Grid, Typography } from '@mui/material';

import { Icon, useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

export default function CommercialCampaignsDetailsSectionStats({ stats }: { stats: any }) {
	const { t } = useSettings();

	return (
		<DetailsSectionWrapper avatar={<Icon icon="chart-bar" />} title={t('COMMERCIALCAMPAIGNS_STATS_SECTION')}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid>
					<Grid container direction="column" justifyContent="space-between" spacing={1}>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_VALUE_EXPENSES')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_VALUE_PLANNED')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_N_OPPORTUNITIES')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_N_LEADS')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_N_CUSTOMERS')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_LEAD_CONVERSION')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_CAC')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('COMMERCIALCAMPAIGNS_STATISTICS_CPA')}</Typography>
						</Grid>
					</Grid>
				</Grid>
				<Grid>
					<Grid container direction="column" justifyContent="space-between" spacing={1}>
						<Grid size={12}>
							<Typography align="right">{Utils.formatCurrency(stats.cmcp_expenses || 0)}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">{Utils.formatCurrency(stats.cmcp_value_planned || 0)}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">{stats.cmcp_n_opportunities}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">{stats.cmcp_n_leads}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">{stats.cmcp_n_customers}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">
								{stats.cmcp_n_customers && stats.cmcp_n_leads
									? Utils.formatPercentage(stats.cmcp_n_customers / stats.cmcp_n_leads)
									: '-'}
							</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">
								{stats.cmcp_n_customers > 0
									? Utils.formatCurrency((stats.cmcp_expenses || 0) / stats.cmcp_n_customers)
									: '-'}
							</Typography>
						</Grid>
						<Grid size={12}>
							<Typography align="right">
								{stats.cmcp_n_opportunities > 0
									? Utils.formatCurrency((stats.cmcp_expenses || 0) / stats.cmcp_n_opportunities)
									: '-'}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</DetailsSectionWrapper>
	);
}
